// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../3.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../3hh.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form {
  background-image: linear-gradient(
      180deg,
      rgba(247, 196, 196, 0),
      rgba(220, 220, 248, 0)
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
}

h1 {
  font-size: medium;
  text-align: center;
  color: rgb(61, 56, 56);
  margin-bottom: 1.5rem;
}

h1 span {
  color: rgb(105, 99, 99);
  font-size: xx-large;
  letter-spacing: 0.2rem;
  font-weight: 700;
}

.container-1 {
  display: flex;
  justify-content: space-between;
}

.submission_cer {
  display: inline-block;
  background-image: linear-gradient(
      rgba(247, 196, 196, 0),
      rgba(220, 220, 248, 0)
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  padding-top: 7rem;
  position: relative;
  height: 53rem;
  width: 73rem;
  position: relative;
  margin-top: 15rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
}
/* Media query for phones (0 - 600px) */
@media (max-width: 600px) {
  .submission_cer {
    top: 50%;
    left: 85%;
    transform: translate(-50%, -50%);
    height: 29rem;
    width: 40rem;
    font-size: 0.8rem;
    margin-top: 25rem;
    padding-top: 5rem;
  }
}

/* Media query for Tablet portrait (600px - 900px) */
@media (min-width: 601px) and (max-width: 900px) {
  .submission_cer {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 33rem;
    width: 43rem;
    font-size: small;
    margin-top: 30rem;
    padding-top: 6rem;
  }
}

/* Media query for Tablet landscape (900px - 1200px) */
@media (min-width: 901px) and (max-width: 1200px) {
  .submission_cer {
    height: 40rem;
    width: 53rem;
    font-size: small;
    margin-top: 30rem;
  }
}

@media (min-width: 1200px) and (max-width: 1800px) {
  .submission_cer {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 53rem;
    width: 73rem;
    margin-top: 30rem;
    padding-top: 10rem;
    font-size: 1.8rem;
  }
}

/* Media query for larger screens (1800px +) */
@media (min-width: 1801px) {
  .submission_cer {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 63rem;
    width: 83rem;
    margin-top: 35rem;
    padding-top: 10rem;
    font-size: 1.8rem;
    font-size: xx-large;
  }
}

@media (min-width: 1200px) and (max-width: 1800px) {
  .submission_cer-h1 {
    font-size: xx-large;
  }
}

@media (min-width: 1801px) {
  .submission_cer-h1 {
    font-size: 2.5rem;
  }
}

@media (max-width: 600px) {
  .submission_cer-h1-span {
    font-size: 2rem;
  }
}
@media (min-width: 1200px) and (max-width: 1800px) {
  .submission_cer-h1-span {
    font-size: 4rem;
  }
}

@media (min-width: 1801px) {
  .submission_cer-h1-span {
    font-size: 4rem;
    font-weight: 900;
  }
}

.submission_cer-award {
  margin-top: 1rem;
}

@media (max-width: 600px) {
  .submission_cer-award {
    margin-top: 1.5rem;
    margin-bottom: 2rem;
    font-size: 1rem;
  }
}

@media (min-width: 1200px) and (max-width: 1800px) {
  .submission_cer-award {
    margin-top: 3rem;
  }
}

@media (min-width: 1801px) {
  .submission_cer-award {
    font-size: 1.7rem;
    margin: 2rem 0;
  }
}

.submission_vol {
  border-bottom: 1px solid rgb(61, 56, 56);
  color: rgb(61, 56, 56);
  display: inline-block;
  text-decoration: none;
  font-size: x-large;
  margin: 2rem 0;
  text-transform: capitalize;
}

@media (max-width: 600px) {
  .submission_vol {
    margin: 1rem 0;
    font-size: 1.4rem;
  }
}
@media (min-width: 601px) and (max-width: 900px) {
  .submission_vol {
    margin: 0.5rem 0;
  }
}
@media (min-width: 1200px) and (max-width: 1800px) {
  .submission_vol {
    margin: 2rem 0;
    font-size: 2rem;
  }
}
@media (min-width: 1801px) {
  .submission_vol {
    font-size: 2rem;
    margin: 3rem 0;
  }
}

.submission-amount {
  margin-top: 0rem;

  color: rgb(105, 99, 99);
}
@media (max-width: 600px) {
  .submission-amount {
    margin: 0 0;
    font-size: 1.2rem;
  }
}

.submission-note {
  margin: 1rem 0;
  font-size: medium;
  color: rgb(61, 56, 56);
  text-transform: capitalize;
}
@media (max-width: 600px) {
  .submission-note {
    margin: 0.1rem 0;
    margin-bottom: 2rem;
    font-size: 1rem;
  }
}
@media (min-width: 601px) and (max-width: 900px) {
  .submission-note {
    margin: 1rem 0;
  }
}
@media (min-width: 1200px) and (max-width: 1800px) {
  .submission-note {
    margin: 1.7rem 0;
    font-size: 1.5rem;
  }
}
@media (min-width: 1801px) {
  .submission-note {
    font-size: 1.5rem;
    margin: 3rem 0;
  }
}

.submission-date {
  position: absolute;
  text-align: left;
  margin-left: 5rem;
  text-decoration: none;
  margin-top: 3rem;
}
@media (max-width: 600px) {
  .submission-date {
    margin-top: 0;
    font-size: 1rem;
  }
}
@media (min-width: 601px) and (max-width: 900px) {
  .submission-date {
    margin-top: 1.5rem;
  }
}

@media (min-width: 1801px) {
  .submission-date {
    font-size: 2rem;
    margin: 3rem 5rem;
  }
}
.submission-date-1 {
  border-bottom: 1px solid rgb(61, 56, 56);
}

@media (max-width: 600px) {
  .submission-date-1 {
    margin-bottom: 0rem;
  }
}
.submission-date-2 {
  margin-top: 1rem;
  text-align: center;
}
@media (max-width: 600px) {
  .submission-date-2 {
    margin-top: 0rem;
  }
}

.submission-send {
  position: absolute;
  text-align: right;
  right: 3rem;
  display: inline-block;
  text-decoration: none;
  margin-right: 2rem;
  margin-top: 3rem;
  text-align: center;
}
@media (max-width: 600px) {
  .submission-send {
    margin-top: 0;
    font-size: 1rem;
  }
}
@media (min-width: 601px) and (max-width: 900px) {
  .submission-send {
    margin-top: 1.5rem;
  }
}

@media (min-width: 1801px) {
  .submission-send {
    font-size: 2rem;
    margin: 3rem 5rem;
  }
}
.submission-send_1 {
  text-transform: capitalize;
  border-bottom: 1px solid rgb(61, 56, 56);
}
@media (max-width: 600px) {
  .submission-send_2 {
    margin-top: -1rem;
  }
}

.btnDiv {
  text-align: center;
  margin-top: -15rem;
}
.button {
  background-color: rgb(131, 191, 243);
  color: black;
  font-weight: bolder;
  height: 3rem;
  font-size: large;
}

@media (max-width: 600px) {
  .btnDiv {
    margin-top: -12rem;
    text-align: right;
  }
}

@media (min-width: 1200px) and (max-width: 1800px) {
  .btnDiv {
    margin-top: -25rem;
  }
}

@media (min-width: 1801px) {
  .btnDiv {
    margin-top: -30rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/InvoiceForm.css"],"names":[],"mappings":"AAAA;EACE;;;;;2CAKe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB;;;;2CAIiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB;sDACoD;AACtD;AACA,uCAAuC;AACvC;EACE;IACE,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,oDAAoD;AACpD;EACE;IACE,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA,sDAAsD;AACtD;EACE;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE;IACE,cAAc;IACd,iBAAiB;EACnB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,cAAc;IACd,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;;EAEhB,uBAAuB;AACzB;AACA;EACE;IACE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;IACb,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;IACb,eAAe;EACjB;AACF;AACA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,0BAA0B;EAC1B,wCAAwC;AAC1C;AACA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".form {\r\n  background-image: linear-gradient(\r\n      180deg,\r\n      rgba(247, 196, 196, 0),\r\n      rgba(220, 220, 248, 0)\r\n    ),\r\n    url(../3.png);\r\n  background-size: cover;\r\n  background-position: center;\r\n}\r\n\r\nh1 {\r\n  font-size: medium;\r\n  text-align: center;\r\n  color: rgb(61, 56, 56);\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\nh1 span {\r\n  color: rgb(105, 99, 99);\r\n  font-size: xx-large;\r\n  letter-spacing: 0.2rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.container-1 {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.submission_cer {\r\n  display: inline-block;\r\n  background-image: linear-gradient(\r\n      rgba(247, 196, 196, 0),\r\n      rgba(220, 220, 248, 0)\r\n    ),\r\n    url(../3hh.png);\r\n  background-size: cover;\r\n  padding-top: 7rem;\r\n  position: relative;\r\n  height: 53rem;\r\n  width: 73rem;\r\n  position: relative;\r\n  margin-top: 15rem;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  text-align: center;\r\n  font-family: \"Lucida Sans\", \"Lucida Sans Regular\", \"Lucida Grande\",\r\n    \"Lucida Sans Unicode\", Geneva, Verdana, sans-serif;\r\n}\r\n/* Media query for phones (0 - 600px) */\r\n@media (max-width: 600px) {\r\n  .submission_cer {\r\n    top: 50%;\r\n    left: 85%;\r\n    transform: translate(-50%, -50%);\r\n    height: 29rem;\r\n    width: 40rem;\r\n    font-size: 0.8rem;\r\n    margin-top: 25rem;\r\n    padding-top: 5rem;\r\n  }\r\n}\r\n\r\n/* Media query for Tablet portrait (600px - 900px) */\r\n@media (min-width: 601px) and (max-width: 900px) {\r\n  .submission_cer {\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    height: 33rem;\r\n    width: 43rem;\r\n    font-size: small;\r\n    margin-top: 30rem;\r\n    padding-top: 6rem;\r\n  }\r\n}\r\n\r\n/* Media query for Tablet landscape (900px - 1200px) */\r\n@media (min-width: 901px) and (max-width: 1200px) {\r\n  .submission_cer {\r\n    height: 40rem;\r\n    width: 53rem;\r\n    font-size: small;\r\n    margin-top: 30rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) and (max-width: 1800px) {\r\n  .submission_cer {\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    height: 53rem;\r\n    width: 73rem;\r\n    margin-top: 30rem;\r\n    padding-top: 10rem;\r\n    font-size: 1.8rem;\r\n  }\r\n}\r\n\r\n/* Media query for larger screens (1800px +) */\r\n@media (min-width: 1801px) {\r\n  .submission_cer {\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    height: 63rem;\r\n    width: 83rem;\r\n    margin-top: 35rem;\r\n    padding-top: 10rem;\r\n    font-size: 1.8rem;\r\n    font-size: xx-large;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) and (max-width: 1800px) {\r\n  .submission_cer-h1 {\r\n    font-size: xx-large;\r\n  }\r\n}\r\n\r\n@media (min-width: 1801px) {\r\n  .submission_cer-h1 {\r\n    font-size: 2.5rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .submission_cer-h1-span {\r\n    font-size: 2rem;\r\n  }\r\n}\r\n@media (min-width: 1200px) and (max-width: 1800px) {\r\n  .submission_cer-h1-span {\r\n    font-size: 4rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1801px) {\r\n  .submission_cer-h1-span {\r\n    font-size: 4rem;\r\n    font-weight: 900;\r\n  }\r\n}\r\n\r\n.submission_cer-award {\r\n  margin-top: 1rem;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .submission_cer-award {\r\n    margin-top: 1.5rem;\r\n    margin-bottom: 2rem;\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) and (max-width: 1800px) {\r\n  .submission_cer-award {\r\n    margin-top: 3rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1801px) {\r\n  .submission_cer-award {\r\n    font-size: 1.7rem;\r\n    margin: 2rem 0;\r\n  }\r\n}\r\n\r\n.submission_vol {\r\n  border-bottom: 1px solid rgb(61, 56, 56);\r\n  color: rgb(61, 56, 56);\r\n  display: inline-block;\r\n  text-decoration: none;\r\n  font-size: x-large;\r\n  margin: 2rem 0;\r\n  text-transform: capitalize;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .submission_vol {\r\n    margin: 1rem 0;\r\n    font-size: 1.4rem;\r\n  }\r\n}\r\n@media (min-width: 601px) and (max-width: 900px) {\r\n  .submission_vol {\r\n    margin: 0.5rem 0;\r\n  }\r\n}\r\n@media (min-width: 1200px) and (max-width: 1800px) {\r\n  .submission_vol {\r\n    margin: 2rem 0;\r\n    font-size: 2rem;\r\n  }\r\n}\r\n@media (min-width: 1801px) {\r\n  .submission_vol {\r\n    font-size: 2rem;\r\n    margin: 3rem 0;\r\n  }\r\n}\r\n\r\n.submission-amount {\r\n  margin-top: 0rem;\r\n\r\n  color: rgb(105, 99, 99);\r\n}\r\n@media (max-width: 600px) {\r\n  .submission-amount {\r\n    margin: 0 0;\r\n    font-size: 1.2rem;\r\n  }\r\n}\r\n\r\n.submission-note {\r\n  margin: 1rem 0;\r\n  font-size: medium;\r\n  color: rgb(61, 56, 56);\r\n  text-transform: capitalize;\r\n}\r\n@media (max-width: 600px) {\r\n  .submission-note {\r\n    margin: 0.1rem 0;\r\n    margin-bottom: 2rem;\r\n    font-size: 1rem;\r\n  }\r\n}\r\n@media (min-width: 601px) and (max-width: 900px) {\r\n  .submission-note {\r\n    margin: 1rem 0;\r\n  }\r\n}\r\n@media (min-width: 1200px) and (max-width: 1800px) {\r\n  .submission-note {\r\n    margin: 1.7rem 0;\r\n    font-size: 1.5rem;\r\n  }\r\n}\r\n@media (min-width: 1801px) {\r\n  .submission-note {\r\n    font-size: 1.5rem;\r\n    margin: 3rem 0;\r\n  }\r\n}\r\n\r\n.submission-date {\r\n  position: absolute;\r\n  text-align: left;\r\n  margin-left: 5rem;\r\n  text-decoration: none;\r\n  margin-top: 3rem;\r\n}\r\n@media (max-width: 600px) {\r\n  .submission-date {\r\n    margin-top: 0;\r\n    font-size: 1rem;\r\n  }\r\n}\r\n@media (min-width: 601px) and (max-width: 900px) {\r\n  .submission-date {\r\n    margin-top: 1.5rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1801px) {\r\n  .submission-date {\r\n    font-size: 2rem;\r\n    margin: 3rem 5rem;\r\n  }\r\n}\r\n.submission-date-1 {\r\n  border-bottom: 1px solid rgb(61, 56, 56);\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .submission-date-1 {\r\n    margin-bottom: 0rem;\r\n  }\r\n}\r\n.submission-date-2 {\r\n  margin-top: 1rem;\r\n  text-align: center;\r\n}\r\n@media (max-width: 600px) {\r\n  .submission-date-2 {\r\n    margin-top: 0rem;\r\n  }\r\n}\r\n\r\n.submission-send {\r\n  position: absolute;\r\n  text-align: right;\r\n  right: 3rem;\r\n  display: inline-block;\r\n  text-decoration: none;\r\n  margin-right: 2rem;\r\n  margin-top: 3rem;\r\n  text-align: center;\r\n}\r\n@media (max-width: 600px) {\r\n  .submission-send {\r\n    margin-top: 0;\r\n    font-size: 1rem;\r\n  }\r\n}\r\n@media (min-width: 601px) and (max-width: 900px) {\r\n  .submission-send {\r\n    margin-top: 1.5rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1801px) {\r\n  .submission-send {\r\n    font-size: 2rem;\r\n    margin: 3rem 5rem;\r\n  }\r\n}\r\n.submission-send_1 {\r\n  text-transform: capitalize;\r\n  border-bottom: 1px solid rgb(61, 56, 56);\r\n}\r\n@media (max-width: 600px) {\r\n  .submission-send_2 {\r\n    margin-top: -1rem;\r\n  }\r\n}\r\n\r\n.btnDiv {\r\n  text-align: center;\r\n  margin-top: -15rem;\r\n}\r\n.button {\r\n  background-color: rgb(131, 191, 243);\r\n  color: black;\r\n  font-weight: bolder;\r\n  height: 3rem;\r\n  font-size: large;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .btnDiv {\r\n    margin-top: -12rem;\r\n    text-align: right;\r\n  }\r\n}\r\n\r\n@media (min-width: 1200px) and (max-width: 1800px) {\r\n  .btnDiv {\r\n    margin-top: -25rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 1801px) {\r\n  .btnDiv {\r\n    margin-top: -30rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
